import React, { useState } from "react";
import logo from "../src/assets/components/images/Lanao_del_Norte_Seal.png";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faLock } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "./authprovider"; // Adjust the import path as necessary
import Swal from "sweetalert2";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = (event) => {
    event.preventDefault();

    axios
      .post("https://brgytracerappserver.onrender.com/login", {
        username,
        password,
      })
      .then((res) => {
        console.log(res);
        if (res.data.status === "success") {
          const userBrgyId = res.data.brgyId;
          const userRole = res.data.role;
          login({ role: userRole, brgyId: userBrgyId });
          if (userRole === "admin") {
            Swal.fire({
              icon: "success",
              title: "Welcome Admin!",
              showConfirmButton: true,
            }).then(() => {
              navigate("/adminpage");
            });
          } else if (userRole === "member") {
            Swal.fire({
              icon: "success",
              title: "Welcome User!",
              showConfirmButton: true,
            }).then(() => {
              navigate(`/memberpage/${userBrgyId}`);
            });
          } else if (userRole === "officer") {
            Swal.fire({
              icon: "success",
              title: "Welcome Officer!",
              showConfirmButton: true,
            }).then(() => {
              navigate("/officerpage");
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Unrecognized role!",
            });
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Unregistered Account!",
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Something went wrong!",
          text: "System error!! Please refresh",
        });
      });
  };

  return (
    <div className="login-parent login">
      <div className="login-holder">
        <h3> Login Form </h3>
        <form onSubmit={handleSubmit}>
          <div className="imguser-container">
            <img src={logo} alt="" title="" width="300px" height="300px" />
          </div>
          <div className="textbox-container">
            <div className="username-parent">
              <FontAwesomeIcon icon={faUser} />
              <input
                type="username"
                id="user"
                placeholder="username"
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div className="password-parent">
              <FontAwesomeIcon icon={faLock} />
              <input
                type="password"
                id="pass"
                placeholder="password"
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <button>Login</button>
            <Link to="/register">Create Account</Link>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
